import { render, staticRenderFns } from "./ImmediateDiscountGuide.vue?vue&type=template&id=2a2797d2&"
import script from "./ImmediateDiscountGuide.vue?vue&type=script&lang=ts&"
export * from "./ImmediateDiscountGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports